<!--
 * @Author: 范向玲
 * @Date: 2023-02-27 17:41:00
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-11-14 11:22:08
 * @Description: 重置密码
 * @FilePath: \web\src\components\DataManagement\institutionManagement\psdReset.vue
-->
<template>
  <section id="add-user">
    <a-form
      ref="psdResetForm"
      :model="formData"
      name="basic"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
      autocomplete="off"
    >
      <a-form-item label="密码" name="password" :rules="[{ trigger: 'blur', required: true, message: '请输入!' }, { validator: validatePassword, trigger: 'blur' }]">
        <a-input-password v-model:value="formData.password" style="background-color:transparent;border-color:#695933" />
      </a-form-item>
      <a-form-item label="确认密码" name="surePassword" :rules="[{ required: true, message: '请输入!' }, { validator: validateSurePassword, trigger: 'blur' }]">
        <a-input-password v-model:value="formData.surePassword" style="background-color:transparent;border-color:#695933" />
      </a-form-item>
    </a-form>
  </section>
</template>

<script setup>
import { CaretDownOutlined, } from '@ant-design/icons-vue';
import { ref, reactive, computed, toRefs, watch, onMounted, onBeforeMount, defineProps, defineEmits, defineExpose, } from 'vue';
import { checkEmail, checkPhone, checkPws, } from '@/utils/utils';

const props = defineProps({
  formState: {
    required: true,
  },
  orgTree: {
    require: true,
  },
  roleList: {
    require: true,
  },
  modalType: {
    require: true,
  },
});


let formData = JSON.parse(JSON.stringify(props.formState));

/* 密码校验 */
const validatePassword = (rule, value, callback) => {
  if (value) {
    if (checkPws(value)) {
      callback();
    } else {
      callback(new Error('密码长度为8-18个字符，必须包含大写字母、小写字母、数字、特殊字符（!@#$%^&*?）四种组合。'));
    }
  } else {
    callback();
  }
};
/* 确认密码 */
const validateSurePassword = (rule, value, callback) => {
  if (value) {
    if (value !== props.formState.password) {
      callback(new Error('两次输入的密码不一致'));
      return false;
    }
    callback();
  }
};

const validatePhone = (rule, value, callback) => {
  if (value) {
    if (checkPhone(value)) {
      callback();
    } else {
      callback(new Error('联系方式格式不正确！'));
    }
  } else {
    callback();
  }
};
const validateEmail = (rule, value, callback) => {
  if (value) {
    if (checkEmail(value)) {
      callback();
    } else {
      callback(new Error('邮箱格式不正确！'));
    }
  } else {
    callback();
  }
};


const psdResetForm = ref();
const emit = defineEmits(['confirmAdd',]);

defineExpose({psdResetForm,});

// const confirmAdd = () => {
//   emit('addmoooo', )
// };

watch(props.formState, (val, old) => {
  if (val) {
    formData = val;
  }
}, {
  deep: true,
  immediate: true,
});

</script>

<style lang="scss">
#add-user {
  .ant-form-item-label > label {
    color: #fff;
  }
  /** 下拉框 */
  .ant-select {
    width: 100%;
    height: 100%;
    // height: 0.34rem;
    // padding: 0.1rem;

    .ant-select-selector {
      height: 100%;
      // height: 0.34rem;
    }

    .ant-select-arrow {
      color: #fff;
    }

    .ant-select-selection-item {
      line-height: .34rem;
      // height: 0.34rem;
    }

    // 背景
    &:not(.ant-select-customize-input) .ant-select-selector {
      // background-color: rgba(91, 76, 39, 0.4);
      background-color: transparent;
      border: 1px solid #695933;
      color: #fff;
    }

    /* 描述 */
    .ant-select-selection-placeholder {
      line-height: .34rem;
      // height: 0.34rem;
      color: #fff;
    }
  }
  .ant-select-multiple .ant-select-selection-item {
    background-color: rgba(91, 76, 39, 0.4);
  }
  .ant-select-multiple .ant-select-selection-item-content {
    margin-top: -0.1rem;
    padding-top: 0.05rem;
  }
  .ant-select-multiple .ant-select-selection-item-remove {
    color: #fff;
    margin-top: -0.05rem;
  }
  span .ant-input-password .ant-input-affix-wrapper {
    background-color: transparent;
  }
  .ant-input-password-icon {
    color: #fff;
  }
}
</style>